module.exports = __webpack_public_path__ + "img/nl.e5f5b452.svg";